import { render, staticRenderFns } from "./PrivacyCardView.vue?vue&type=template&id=60b6afd8&scoped=true"
import script from "./PrivacyCardView.vue?vue&type=script&lang=ts"
export * from "./PrivacyCardView.vue?vue&type=script&lang=ts"
import style0 from "./PrivacyCardView.vue?vue&type=style&index=0&id=60b6afd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b6afd8",
  null
  
)

export default component.exports